import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.prototype.axios = axios

Vue.use(Vuetify)

const vuetifyOpts = {
  icons: {
    values: {},
    iconfont: 'fa'
  }
}

new Vue({
  vuetify: new Vuetify(vuetifyOpts),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
